import {FC, useEffect, useState} from 'react';
import {IonRadio, IonRadioGroup} from '@ionic/react';

type HealthDeclarationRadioButtonsProps = {
  id: number;
  selectedCheckboxes: Array<any>;
  setSelectedCheckboxes: Function;
  currentQuestionId: number;
  selected: Array<any>;
}

const HealthDeclarationRadioButtons: FC<HealthDeclarationRadioButtonsProps> = ({
  id,
  selectedCheckboxes,
  setSelectedCheckboxes,
  currentQuestionId,
  selected,
}) => {
  const [checked, setChecked] = useState<string>('');

  useEffect(() => {
    if (Object.keys(selectedCheckboxes).length === 0) {
      setChecked('');
    }
  }, [selectedCheckboxes]);

  useEffect(() => {
    if (selected.filter((el: any) => el.id === currentQuestionId).length > 0) {
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].id === currentQuestionId) {
          for (let j = 0; j < selected[i].answers.length; j++) {
            if (selected[i].answers[j].answer_id === id) {
              setChecked(selected[i].answers[j].value);
            }
          }
        }
      }
    }
  }, [selected, currentQuestionId]);

  const handleClick = (value: any, id: number) => {
    setChecked(value);
    const tmpAnswers = [...selectedCheckboxes];
    tmpAnswers.push({'id': id, 'value': value});
    setSelectedCheckboxes(tmpAnswers);
  };

  return (
    <IonRadioGroup value={checked} onIonChange={(e) => handleClick(e.target.value, id)} className='flex space-x-4'>
      <IonRadio
        mode='ios'
        slot="start"
        value="yes"
        className='w-6 h-6 rounded bg-gray-lightButton'/>
      <IonRadio
        mode='ios'
        slot="start"
        value="no"
        className='w-6 h-6 rounded bg-gray-lightButton'/>
    </IonRadioGroup>
  );
};

export default HealthDeclarationRadioButtons;
